import {post} from '@/request/request';

/**
 * 获取素材列表
 * @returns {*}
 */
export function geIndex(data) {
    return post("Photos/index",{
        category_id: data.category_id,
        page: data.page,
        limit: 14,
    })
}

/**
 * 修改素材名称
 * @param data
 */
export function editName(data) {
    return post("Photos/editName",{
        id: data.id,
        name: data.name,
    });
}/**
 * 修改素材名称
 * @param data
 */
export function editResCat(data) {
    return post("Photos/editCat",{
        id: data.id,
        cat_id: data.cat_id,
        ids:data.ids ? data.ids : '',
    });
}

/**
 * 删除素材
 * @param data
 */
export function deleteResCat(data) {
    return post("Photos/destroy",{
        id: data.id,
        ids:data.ids ? data.ids : '',
    });
}

/**
 * 获取分类列表
 * @returns {*}
 */
export function geCattIndex(data) {
    return post("PhoCate/index",{
        title:data.title,
    })
}

/**
 * 获取分类列表 带图片数量的
 * @returns {*}
 */
export function geCattCountIndex() {
    return post("PhoCate/getCatCount",{})
}
/**
 * 创建分类
 * @returns {*}
 */
export function createCat(data) {
    return post("PhoCate/store",data);
}

/**
 * 修改分类
 * @param data
 * @returns {*}
 */
export function editCat(data) {
    return post("PhoCate/edit",data);
}


/**
 * 删除分类
 * @param data
 * @returns {*}
 */
export function deleteCat(data) {
    return post("PhoCate/destroy",{
        category_id:data.category_id,
    });
}
